import { Col, Container, Row, ProgressBar, Button } from "react-bootstrap";
import { BsCaretRight, BsCheckLg } from "react-icons/bs";
import { useEffect, useState } from "react";
import ChangePlanModal from "./PlanChangeModal";
import "../../../assets/css/loadingwrapper.css";
import Invoices from "./InvoicesTable";
import Transactions from "./Transactions Table";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import PaymentMethods from "./PaymentMethods";
import { useSelector, useDispatch } from "react-redux";
import { getPaymentDataByAccountID } from "../../../Redux/Auth/actions";
import {
  stripeCustomerData,
  stripeCustomerPaymentMethodData,
  stripeProductData,
  stripeSubscription,
} from "../../../Redux/Stripe/action";
import { CustomerQuotaAndCalls } from "../../../Redux/Quota/action";


const Billing = () => {
  const dispatch = useDispatch();
  const [subscription, setSubscription] = useState();
  const [product, setProduct] = useState();
  const [showModal, setShowModal] = useState(false);
  const [cardDetails, setCardDetails] = useState(false);
  const [customerData, setCustomerData] = useState();
  const user = useSelector((state) => state.authReducer.data);
  const paymentData = useSelector((state) => state.authReducer.paymentData);
  const CustomerQuotaAndCallsData = useSelector(
    (state) => state.quotaReducer.CustomerQuotaAndCallsByIdSuccess,
  );
  const subscriptionByIDSuccess = useSelector(
    (state) => state.stripeReducer.subscriptionByIdSuccess,
  );
  const productByIDSuccess = useSelector(
    (state) => state.stripeReducer.productByIdSuccess,
  );
  const customerByIDSuccess = useSelector(
    (state) => state.stripeReducer.customerByIdSuccess,
  );
  const customerPaymentMethodByIdSuccess = useSelector(
    (state) => state.stripeReducer.customerPaymentMethodByIdSuccess,
  );
  const [packageStartData, setPackageStartData] = useState();
  const [packageEndData, setPackageEndData] = useState();
  const handleModalShow = () => setShowModal(true);
  const handleModalClose = () => setShowModal(false);
  useEffect(() => {
    getPaymentDataByAccountID(dispatch, user.accountID);
    CustomerQuotaAndCalls(dispatch, user.accountID);
  }, []);

  useEffect(() => {
    if (paymentData) {
      const fetchData = async () => {
        await stripeSubscription(dispatch, paymentData?.subscriptionID);
      };
      fetchData();
    }
  }, [paymentData]);
  useEffect(() => {
    if (subscriptionByIDSuccess) {
      setSubscription(subscriptionByIDSuccess);
    }
  }, [subscriptionByIDSuccess]);
  useEffect(() => {
    if (subscription) {
      const fetchData = async () => {
        await stripeProductData(dispatch, subscription?.plan?.product);
      };
      fetchData();
    }
  }, [subscription]);
  useEffect(() => {
    if (productByIDSuccess) {
      setProduct(productByIDSuccess);
    }
  }, [productByIDSuccess]);
  useEffect(() => {
    if (paymentData) {
      const fetchData = async () => {
        await stripeCustomerData(dispatch, paymentData?.customerID);
      };
      fetchData();
    }
  }, [paymentData]);
  useEffect(() => {
    if (customerByIDSuccess) {
      setCustomerData(customerByIDSuccess);
    }
  }, [customerByIDSuccess]);

  useEffect(() => {
    if (customerData) {
      const fetchData = async () => {
        await stripeCustomerPaymentMethodData(
          dispatch,
          paymentData?.customerID,
          customerData?.invoice_settings?.default_payment_method,
        );
      };
      fetchData();
    }
  }, [customerData]);

  useEffect(() => {
    if (customerPaymentMethodByIdSuccess) {
      setCardDetails(customerPaymentMethodByIdSuccess);
    }
  }, [customerPaymentMethodByIdSuccess]);

  useEffect(() => {
    const options = { day: "numeric", month: "short", year: "numeric" };

    const endDate = new Date(
      subscription?.current_period_end * 1000,
    ).toLocaleDateString("en-US", options);
    const startDate = new Date(
      subscription?.current_period_start * 1000,
    ).toLocaleDateString("en-US", options);
    setPackageStartData(startDate);
    setPackageEndData(endDate);
  }, [subscription]);

  let packagePrice = subscription?.plan?.amount / 100;
  let totalMinutes = product?.metadata.quota;
  let usedMinutes = CustomerQuotaAndCallsData?.usedUnits || "Calculating...";
  let usedMinutesPercentage = (usedMinutes / totalMinutes) * 100;
  let noOfCalls = CustomerQuotaAndCallsData?.noOfCalls || "Calculating...";

  useEffect(() => {
    packagePrice = subscription?.plan?.amount / 100;
    totalMinutes = product?.metadata.quota;
    usedMinutes = CustomerQuotaAndCallsData?.usedUnits || "Calculating...";
    usedMinutesPercentage = (usedMinutes / totalMinutes) * 100;
    noOfCalls = CustomerQuotaAndCallsData?.noOfCalls || "Calculating...";
  }, [
    stripeCustomerData,
    stripeCustomerPaymentMethodData,
    stripeProductData,
    stripeSubscription,
  ]);
  return (
    <Container>
      <Row>
        <Col>
          {/*Billing Summary & Plan Details*/}
          <div className="p-md-5 border shadow mb-3 rounded mt-3">
            <Row>
              <Col>
                <h5 className={"main-h4-tag-large mb-5"}>Billing Summary</h5>
                <div className="d-flex justify-content-between general-orderOverview-text">
                  <p>Total Due</p>
                  <p>$0.00</p>
                </div>
                <div className="d-flex justify-content-between general-orderOverview-text">
                  <p>Past Due</p>
                  <p>$0.00</p>
                </div>
                <div className="d-flex justify-content-between general-orderOverview-text">
                  <p>Recent Charges</p>
                  <p>$0.00</p>
                </div>
                <div className="d-flex justify-content-between general-orderOverview-text">
                  <p>Recent Transactions</p>
                  <p>$0.00</p>
                </div>
              </Col>
              <Col>
                <div className="d-flex justify-content-between">
                  <h5 className={"main-h4-tag-large mb-3"}> Plan Details</h5>
                  <h5
                    onClick={handleModalShow}
                    className={"custom-style-settings-menu-bold mt-1"}
                    style={{ cursor: "pointer" }}
                  >
                    Change Plan <BsCaretRight />
                  </h5>
                  <ChangePlanModal
                    subscriptionDetails={subscription}
                    isOpen={showModal}
                    closeModal={handleModalClose}
                  />
                </div>
                <Col>
                  {totalMinutes ? (
                    <>
                      <div
                        className="p-md-3 border"
                        style={{
                          backgroundColor: "#f6f7f7",
                          borderRadius: "8%",
                        }}
                      >
                        <div className="d-flex justify-content-between">
                          <p
                            className={
                              "custom-style-settings-menu-minutes-bold"
                            }
                          >
                            Live Answering-{totalMinutes} Minutes
                          </p>
                          <p style={{ color: "#172e57" }}>
                            <strong>${packagePrice}.00</strong>
                          </p>
                        </div>
                        <p className={"custom-style-settings-menu-bold mb-3"}>
                          <BsCheckLg /> IVR
                        </p>
                        <p className={"custom-style-settings-menu-bold mb-3"}>
                          <BsCheckLg /> Addons
                        </p>
                        <ProgressBar
                          style={{ backgroundColor: "lightgray" }}
                          now={usedMinutesPercentage}
                        />
                        <p className={"custom-style-settings-menu-bold mt-2"}>
                          {noOfCalls} Calls (
                          {CustomerQuotaAndCallsData?.totalMinUsed} mins/
                          {totalMinutes} mins){" "}
                        </p>
                        {CustomerQuotaAndCallsData?.totalMinUsed -
                          CustomerQuotaAndCallsData?.units >
                        0 ? (
                          <p className={"custom-style-settings-menu-bold mt-2"}>
                            Overage -{" "}
                            {CustomerQuotaAndCallsData?.totalMinUsed -
                              CustomerQuotaAndCallsData?.units}{" "}
                            mins
                          </p>
                        ) : (
                          ""
                        )}
                      </div>

                      <div></div>
                    </>
                  ) : (
                    <div className="loader">
                      <div className="wrapper">
                        <div className="circle"></div>
                        <div className="line-1"></div>
                        <div className="line-2"></div>
                        <div className="line-3"></div>
                        <div className="line-4"></div>
                      </div>
                    </div>
                  )}
                </Col>
              </Col>
            </Row>
          </div>
          {/*Invoice Details*/}
          <div className="p-md-5 border shadow mb-3 rounded">
            <Row>
              <Col item lg={6}>
                <div className={"d-flex justify-content-between mb-3"}>
                  <h5 className={"main-h4-tag-large"}>Invoice Details</h5>
                  <h5
                    className={"custom-style-settings-menu-bold mt-1"}
                    style={{ cursor: "pointer" }}
                  >
                    Edit <BsCaretRight />
                  </h5>
                </div>
                <div className="d-flex justify-content-between general-orderOverview-text">
                  <p>Business Name</p>
                  <p>Sectem Technologies</p>
                </div>
                <div className="d-flex justify-content-between general-orderOverview-text">
                  <p>Attn To/ PO Number</p>
                  <p>Not Provided</p>
                </div>
                <div className="d-flex justify-content-between">
                  <p className={"w-50"}>Address</p>
                  <p style={{ marginLeft: "3.7rem" }}>
                    70 Basement, Plaza 70, Phase 4 Bahria Town, Islamabad
                  </p>
                </div>
                <div className="d-flex justify-content-between general-orderOverview-text">
                  <p>Billing Cycle</p>

                  <p>
                    {packageStartData} to {packageEndData}
                  </p>
                </div>
              </Col>
              <Col>
                <Row>
                  <PaymentMethods />
                </Row>
              </Col>{" "}
            </Row>
          </div>
          {/*INVOICES AND TRANSACTIONS*/}
          <div className="p-md-5 border shadow mb-3 rounded">
            <Tabs>
              <TabList>
                <Tab>Invoices</Tab>
                <Tab>Transactions</Tab>
              </TabList>
              <TabPanel>
                <Invoices />
              </TabPanel>
              <TabPanel>
                <Transactions />
              </TabPanel>
            </Tabs>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Billing;
